import { Col, Row, Space } from "antd";
import React from "react";
import { SZTIcon2 } from "../../../components/Icons/SZTIcon2";
import { TagStatus, TextItemDetail1, TextItemDetail2 } from "../style";
import styled from "styled-components";
import { useWindowSize } from "../../../hook/useWindowSize";
import { formatMoney, getClassStatustItemStake } from "../../../utils/hepler";
import { MyButton } from "../../../components/Button/style";
import { useApp } from "../../../contexts";
import { SGTIcon } from "../../../components/Icons/SGTIcon";
const Container = styled.div`
  padding: 0 0 0 0;
  border-bottom: ${(props) =>
    props.isborder === "true" ? "0.5px solid #cccccc" : "none"};
  @media (max-width: 1024px) {
    padding: 18px 0 22px 0;
  }
`;

export const StakeOrderItem = ({
  isborder = "true",
  item,
  onClick,
  onClaim,
}) => {
  const size = useWindowSize();
  const { T } = useApp();
  const isMobile = size.width < 1024;
  const classStatus = getClassStatustItemStake(item)

  return (
    <Container className="relative" isborder={isborder}>
      <Row
        className="items-center hidden lg:flex gap-4 lg:gap-0 cursor-pointer"
        onClick={() => onClick(item)}
      >
        <Col lg={1}>
          <SGTIcon width={!isMobile ? 32 : 28} height={!isMobile ? 32 : 28} />
        </Col>
        <Col span={7}>
          <div class="flex items-center gap-[4px]">
            <span className="text-[#000000] text-[16px] lg:text-[18px] lg:leading-[75px] font-semibold leading-[19.5px]">
              SGT
            </span>
            <span className="text-[#000000] text-[12px] lg:text-[14px] lg:leading-[75px] leading-[14.5px] font-medium">
              | {T("Earn SGT and xSGT")}
            </span>
          </div>
        </Col>
        <Col span={6}>
          <div
            className="flex flex-col items-start gap-2 lg:items-baseline lg:flex-row text-start cursor-pointer"
            onClick={() => onClick(item)}
          >
            <TextItemDetail2 weight={400}>
              {formatMoney(item?.amount)}{" "}
              <span className="text-[#000000] leading-[75px]">SGT</span>
            </TextItemDetail2>
          </div>
        </Col>
        <Col className="text-start lg:text-center" span={4}>
          <div className="flex flex-col gap-2 lg:items-baseline lg:flex-row">
            <TextItemDetail2 className="text-[#000000] leading-[75px]">
              {item.year} {T(item.label)}
            </TextItemDetail2>
          </div>
        </Col>
        <Col className="justify-end flex" span={6}>
          <Row gutter={14}>
            <Col>
              {item?.isFinish && !item?.isClose && (
                <MyButton
                  onClick={() => onClaim(item?.id)}
                  style={{ height: 30, width: 105 }}
                  className="primary"
                >
                  {T("Claim")}
                </MyButton>
              )}
            </Col>
            <Col>
              <TagStatus className={classStatus}>{T(classStatus)}</TagStatus>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* mobile */}
      <div className="lg:hidden">
        <Row
          className="items-center gap-[8px] cursor-pointer"
          onClick={() => onClick(item)}
        >
          <Col span={2}>
            <SGTIcon width={28} height={28} />
          </Col>
          <Col span={13}>
            <div class="flex items-center gap-[4px]">
              <span className="text-[#000000] text-[16px] lg:text-[18px] leading-[19.5px] font-semibold"> 
                SGT
              </span>
              <span className="text-[#000000] text-[12px] lg:text-[14px] leading-[14.5px] font-medium">
                | {T("Earn SGT and xSGT")}
              </span>
            </div>
          </Col>
          <Col></Col>
          <Col>
            <TagStatus className={classStatus}>{T(classStatus)}</TagStatus>
          </Col>
        </Row>

        <Row className="items-center mt-[10px] gap-2">
          <Col span={2}>
            <div style={{ width: 28, height: 28 }}></div>
          </Col>
          <Col span={8}>
            <div
              className="flex flex-col items-start gap-2  text-start cursor-pointer"
              onClick={() => onClick(item)}
            >
              <TextItemDetail1>{T("Amount")} </TextItemDetail1>
              <TextItemDetail2 weight={600}>
                {formatMoney(item?.amount)}{" "}
                <span className="font-normal">SGT</span>
              </TextItemDetail2>
            </div>
          </Col>

          <Col className="text-start" span={5}>
            <div className="flex flex-col gap-2 ">
              <TextItemDetail1>{T("Duration")}</TextItemDetail1>
              <TextItemDetail2>
                {item.year} {item.label}
              </TextItemDetail2>
            </div>
          </Col>
          <Col className="relative">
            {item?.isFinish && !item?.isClose && (
              <MyButton
                onClick={() => onClaim(item?.id)}
                style={{
                  height: 25,
                  width: 75,
                  fontSize: "11px",
                  borderRadius: "5px",
                }}
                className="primary"
              >
                {T("Claim")}
              </MyButton>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
};
